import { Store } from './types';

const STORE: Store = {
    app: {}
};

export default STORE;
